import React from 'react';
import { List, Image } from 'semantic-ui-react';
import { interviews } from '../../data';

export const Links = () => {
    return (
        <List selection verticalAlign="middle">
            {interviews.map((interview) => (
                <List.Item href={interview.link}>
                    <Image style={{ backgroundColor: interview.bg }} avatar src={interview.image} />
                    <List.Content>
                        <List.Header>{interview.title}</List.Header>
                    </List.Content>
                </List.Item>
            ))}
        </List>
    );
};
